import { Loader2, MessageCircle, PenSquare, Music, User, Trash2 } from 'lucide-react';

export function ConversationList({ className = '', conversations, selectedConversation, isArtistView, loading, onSelectConversation, onDeleteConversation, onOpenNewMessage }) {
  return (
    <div className={`flex flex-col ${className}`}>
      <div className="p-3 border-b border-[#262626] flex items-center justify-between">
        <h3 className="font-heading font-bold text-sm text-[#A1A1AA] uppercase tracking-wider">Messages</h3>
        {!isArtistView && (
          <button onClick={onOpenNewMessage} className="p-1.5 rounded-lg bg-lime/10 text-lime hover:bg-lime/20 transition-colors" title="New Message" data-testid="new-message-btn">
            <PenSquare className="w-4 h-4" />
          </button>
        )}
      </div>
      {loading ? (
        <div className="flex justify-center py-12"><Loader2 className="w-6 h-6 animate-spin text-lime" /></div>
      ) : conversations.length === 0 ? (
        <div className="text-center py-12 px-4">
          <MessageCircle className="w-10 h-10 mx-auto mb-3 text-[#333]" />
          <p className="text-sm text-[#666] mb-3">{isArtistView ? "Messages from fans appear here" : "No conversations yet"}</p>
          {!isArtistView && (
            <button onClick={onOpenNewMessage} className="text-sm text-lime hover:underline font-medium" data-testid="start-conversation-btn">Message an artist</button>
          )}
        </div>
      ) : (
        <div className="flex-1 overflow-y-auto">
          {conversations.map((conv) => (
            <div
              key={conv.id}
              onClick={() => onSelectConversation(conv)}
              className={`group flex items-center gap-3 p-3 cursor-pointer border-b border-[#1a1a1a] transition-colors ${
                selectedConversation?.id === conv.id ? 'bg-lime/10 border-l-2 border-l-lime'
                : conv.unread_count > 0 ? 'bg-lime/5 hover:bg-[#1a1a1a]' : 'hover:bg-[#1a1a1a]'
              }`}
              data-testid={`conversation-${conv.id}`}
            >
              <div className="w-10 h-10 rounded-full overflow-hidden bg-[#1a1a1a] flex-shrink-0">
                {(!isArtistView && conv.artist_image) ? (
                  <img src={conv.artist_image} alt="" className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center">
                    {isArtistView ? <User className="w-5 h-5 text-[#404040]" /> : <Music className="w-5 h-5 text-[#404040]" />}
                  </div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between">
                  <h4 className={`text-sm truncate ${conv.unread_count > 0 ? 'font-bold' : 'font-medium'}`}>
                    {isArtistView ? conv.user_name : conv.artist_name}
                  </h4>
                  <div className="flex items-center gap-1 flex-shrink-0">
                    {conv.unread_count > 0 && (
                      <span className="w-5 h-5 bg-lime text-black text-xs rounded-full flex items-center justify-center font-bold" data-testid={`unread-badge-${conv.id}`}>
                        {conv.unread_count}
                      </span>
                    )}
                    <button onClick={(e) => onDeleteConversation(e, conv.id)} className="p-1 rounded text-[#555] hover:text-red-400 hover:bg-red-400/10 opacity-0 group-hover:opacity-100 transition-opacity" data-testid={`delete-conversation-${conv.id}`}>
                      <Trash2 className="w-3.5 h-3.5" />
                    </button>
                  </div>
                </div>
                <div className="flex items-center justify-between gap-2">
                  <p className="text-xs text-[#666] truncate">{conv.has_pending_quote ? '$ Quote pending' : (conv.last_message || 'No messages')}</p>
                  {conv.last_message_at && (
                    <span className="text-[10px] text-[#555] flex-shrink-0">{new Date(conv.last_message_at).toLocaleDateString([], { month: 'short', day: 'numeric' })}</span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
